import { Environment } from './environment.model';

export const ENVIRONMENT_DEV: Environment = {
  production: false,
  name: 'dev',
  staticFilesHost: 'https://static.dev.twaice.ai/',
  baseUrlApi: 'https://api.dev.twaice.ai/',
  pshEmbedUrl: 'https://psh.dev.twaice.cloud/psh/login',
  // public identifier for the Transifex project
  transifexToken: '1/e60edf51d3cbc5c2a847caef792f9da32ba18ef6',
  // public Intercom App ID
  intercomAppId: 'thagvi83',
  // public Mixpanel ID
  mixpanelId: '4f213a56d72f86ef826d5cc8b1ed19e9',
};
